import { HttpClient, HttpParams } from '@angular/common/http';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FileSaveService, getQueryParams } from '@hglobal/fin-ui';

import { environment } from '@kr/environment';
import { OrganizationService } from '@kr/services';
import { DictionariesStore } from '@kr/store';

import { adaptDateRangeForTransactionsApi, TransactionsFilters } from './models';

@Injectable()
export class FileDownloadService {
  readonly #http = inject(HttpClient);
  readonly #fileSave = inject(FileSaveService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #dictionariesStore = inject(DictionariesStore);
  readonly #organizationService = inject(OrganizationService);

  download(url: string, filters: TransactionsFilters): void {
    const providerIds = this.#dictionariesStore.providersIds();
    const ids = filters.providerId || providerIds;

    const api = url === 'report' ? '/transactions/report/' : '/transactions/download/';

    this.#http
      .get(`${environment.apiHost}${api}`, {
        responseType: 'blob' as 'json',
        observe: 'response',
        params: this.#getParams(filters, url),
        headers: this.#organizationService.getHttpHeaders(ids),
      })
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(res => {
        const contentDisposition = res.headers.get('content-disposition');
        const match = contentDisposition?.match(/filename="([^"]+)"/);

        const filename = match ? match[1] : 'monthly_report';
        const blob = res.body as Blob;

        this.#fileSave.save(blob, filename);
      });
  }

  #getParams(filters: TransactionsFilters, url: string): HttpParams {
    return url === 'report'
      ? getQueryParams({
          date_from: filters.createdGte,
          date_to: filters.createdLt,
        })
      : getQueryParams(adaptDateRangeForTransactionsApi(filters), ['page', 'limit'], true);
  }
}
